import config from "../../../helper/config";
import APIHandler from "../../../handlers/APIHandler";

export const StudentService = {
  getRegStudentId,
  addRegUploads,
  create_reg_student,
  getAllRegStudents,
  update,
  create,
  getAllStuRegWithPaginationAndSorting,
  getRegUploadsByUser,
  deleteRegUpload,
  updateRegStudent,
  getEnrollments,
  sendEmail,
  getEmailHistoryByStudent,
  getRegBStudentAllDetail,
  getStudentProfileAndTableIds
};

async function deleteRegUpload(container_id, blob_id) {
  const requestOptions = {
    method: "DELETE",
    headers: {
      ...APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
      "Content-Type": "application/json",
    },
  };

  const response = await fetch(
    `${config.oat_api_url}/manage/registration_c/uploads/delete/${container_id}/${blob_id}`,
    requestOptions
  );
  return APIHandler.handleResponse(response);
}
async function getRegUploadsByUser(user_id, user_table_id) {
  const requestOptions = {
    method: "GET",
    headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
  };
  const response = await fetch(
    `${config.oat_api_url}/manage/registration_c/uploads/getByUser/${user_id}/${user_table_id}`,
    requestOptions
  );
  return APIHandler.handleResponse(response);
}
async function create(registration) {
  const requestOptions = {
    method: "POST",
    headers: {
      ...APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
      "Content-Type": "application/json",
    },
    body: registration,
  };

  const response = await fetch(
    `${config.oat_api_url}/manage/registration/students/add`,
    requestOptions
  );
  return APIHandler.handleResponse(response);
}

async function update(student, studentId) {
  const requestOptions = {
    method: "PUT",
    headers: {
      ...APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
      "Content-Type": "application/json",
    },
    body: student,
  };

  const response = await fetch(
    `${config.oat_api_url}/manage/registration/students/update/${studentId}`,
    requestOptions
  );
  return APIHandler.handleResponse(response);
}

async function getAllRegStudents(
  stu_id,
  user_table_id,
  create_user_id,
  create_user_table_id,
  node_mid,
  limit,
  offset,
  sortColumn,
  sortDirection,
  search_term
) {
  const requestOptions = {
    method: "GET",
    headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
  };
  const login_user_id = sessionStorage.getItem("manage_user_id");
  const login_user_table_id = sessionStorage.getItem("table_log_id");
  const response = await fetch(
    `${config.oat_api_url}/manage/registration_c/students/getAllRegStudents/${node_mid}/${limit}/${offset}/${sortColumn}/${sortDirection}?search_term=${search_term}&s_id=${stu_id}&u_t_id=${user_table_id}&cr_u_id=${create_user_id}&cr_u_t_id=${create_user_table_id}&lg_u_id=${login_user_id}&lg_u_t_id=${login_user_table_id}`,
    requestOptions
  );
  return APIHandler.handleResponse(response);
}

async function getRegStudentId() {
  const requestOptions = {
    method: "GET",
    headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
  };

  const response = await fetch(
    `${config.oat_api_url}/manage/registration_c/students/reg-generate-new-student-id`,
    requestOptions
  );
  return APIHandler.handleResponse(response);
}

async function addRegUploads(uploads) {
  const requestOptions = {
    method: "POST",
    headers: {
      ...APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
      "Content-Type": "application/json",
    },
    body: uploads,
  };

  const response = await fetch(
    `${config.oat_api_url}/manage/registration_c/uploads/reg-doc-sub`,
    requestOptions
  );
  return APIHandler.handleResponse(response);
}

async function create_reg_student(registration) {
  const registrationObj = JSON.parse(registration);
  const node_id = registrationObj.node_mid;

  const requestOptions = {
    method: "POST",
    headers: {
      ...APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
      "Content-Type": "application/json",
    },
    body: registration,
  };

  const login_user_id = sessionStorage.getItem("manage_user_id");
  const login_user_table_id = sessionStorage.getItem("table_log_id");

  // Include node_id in the URL
  const response = await fetch(
    `${config.oat_api_url}/manage/registration_c/students/reg-add?lg_u_id=${login_user_id}&lg_u_t_id=${login_user_table_id}&node_id=${node_id}`,
    requestOptions
  );
  return APIHandler.handleResponse(response);
}

async function getAllStuRegWithPaginationAndSorting(
  stu_id,
  user_table_id,
  create_user_id,
  create_user_table_id,
  node_mid,
  limit,
  offset,
  sortColumn,
  sortDirection,
  search_term
) {
  const requestOptions = {
    method: "GET",
    headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
  };
  const login_user_id = sessionStorage.getItem("manage_user_id");
  const login_user_table_id = sessionStorage.getItem("table_log_id");
  const response = await fetch(
    `${config.oat_api_url}/manage/registration/students/getAllStuRegWithPaginationAndSorting/${node_mid}/${limit}/${offset}/${sortColumn}/${sortDirection}?search_term=${search_term}&s_id=${stu_id}&u_t_id=${user_table_id}&cr_u_id=${create_user_id}&cr_u_t_id=${create_user_table_id}&lg_u_id=${login_user_id}&lg_u_t_id=${login_user_table_id}&node_id=${node_mid}`,
    requestOptions
  );
  return APIHandler.handleResponse(response);
}
async function updateRegStudent(student, studentId) {

  const registrationObj = JSON.parse(student);
  const node_id = registrationObj.node_mid;

  const requestOptions = {
    method: "PUT",
    headers: {
      ...APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
      "Content-Type": "application/json",
    },
    body: student,
  };

  const login_user_id = sessionStorage.getItem("manage_user_id");
  const login_user_table_id = sessionStorage.getItem("table_log_id");

  const response = await fetch(
    `${config.oat_api_url}/manage/registration_c/students/update-reg-student/${studentId}?lg_u_id=${login_user_id}&lg_u_t_id=${login_user_table_id}&node_id=${node_id}`,
    requestOptions
  );
  return APIHandler.handleResponse(response);
}
async function getEnrollments(mid, user_id, user_table_id) {
  const requestOptions = {
    method: "GET",
    headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
  };
  const response = await fetch(
    `${config.oat_api_url}/manage/registration_c/students/getEnrollmentForms/${mid}/${user_id}/${user_table_id}`,
    requestOptions
  );
  return APIHandler.handleResponse(response);
}

async function sendEmail(email) {
  const requestOptions = {
    method: "POST",
    headers: {
      ...APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
      "Content-Type": "application/json",
    },
    body: email,
  };

  const response = await fetch(
    `${config.oat_api_url}/manage/registration_c/students/send-reg-email`,
    requestOptions
  );
  return APIHandler.handleResponse(response);
}

async function getEmailHistoryByStudent(id) {
  const requestOptions = {
    method: "GET",
    headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
  };

  const response = await fetch(
    `${config.oat_api_url}/manage/registration_c/students/get-email-history-by-student-id/${id}`,
    requestOptions
  );
  return APIHandler.handleResponse(response);
}

async function getRegBStudentAllDetail(
  user_id,
  user_table_id,
  l_u_id,
  l_u_t_id,
  session_id
){
  const requestOptions = {
    method: "GET",
    headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
  };
  const response = await fetch(
    `${config.oat_api_url}/manage/registration_c/students/reg-std-details/${user_id}/${user_table_id}?cr_u_id=${l_u_id}&cr_u_t_id=${l_u_t_id}&root_node_id=${session_id}`,
    requestOptions
  );
  return APIHandler.handleResponse(response);

}

async function getStudentProfileAndTableIds(
  user_code
){
  const requestOptions = {
    method: "GET",
    headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
  };
  const response = await fetch(
    `${config.oat_api_url}/manage/registration/students/get-student-profile-and-table-ids/${user_code}`,
    requestOptions
  );
  return APIHandler.handleResponse(response);

}
